export default {
    data(){ return {
        unroll: false,
        activated: false,
        ready: false,
        awaiting: null,
        icons_lvl: {
            notify: "question",
            success: "check",
            alert: "exclamation",
            warning: "exclamation-triangle",
        },
        messages: {
            cancel: "Operation canceled due to new request.",
            unknown: "Error unknown, you can call the support",
            areyousure: "Are you sure to do this?",
        },
    }},
    props: {
        tag: { type: String, default: "div" },
    },
    methods: {
        calculPer(a, t){
            return Math.round((a / t) * 100 * 100) / 100;
        },
        number2dec(num){
            return Math.round((num + Number.EPSILON) * 100) / 100;
        },
        addParamUrl( key, value){
            var query=Object.assign({[key]: value }, this.$route.query);
            this.$router.replace( {query});
        },
        hasParamUrl(key){return this.hasKey(this.$route.query, key);},
        getParamUrl(key){return this.$route.query[key];},
        delParamUrl(key){
            var query=Object.assign({}, this.$route.query);
            delete query[key];
            this.$router.replace({query});
        },
        timestamp: () => Date.now(),
        hasKey: (obj, key) => Object.keys(obj).includes(key),
        corObj: obj => (obj && obj.constructor == Object),
        hasObj: obj => (obj && obj.constructor == Object && Object.keys(obj).length),
        corArray: arr => (arr && arr.constructor == Array),
        hasArray: arr => (arr && arr.constructor == Array && arr.length),
        hasOA(oa){ return (this.hasObj(oa) || this.hasArray(oa)); },
        has: obj => (obj && Object.keys(obj).length),
        doRoll(){ this.unroll = !this.unroll; },
        doActive(){ this.activated = !this.activated; },
        doUnroll(){ this.unroll = false; },
        addStr(add, to){ return to.includes(add) ? to : to + " " + add; },
        removeStr(remove, to){ return to.includes(remove) ? to.replace(remove, "") : to; },
        getSmth(smth){ return this[smth] ? smth + this[smth] : ''; },
        getCaret(test){ return test ? "caret-up" : "caret-down"; },
        getCaretRight(test){ return test ? "caret-down" : "caret-right"; },
        getCaretLeft(test){ return test ? "caret-down" : "caret-left"; },
        emitAction(action, data){ this.$emit(action, data); },
        joinIfNotNull(arr, del=" "){ return arr.filter(Boolean).join(del); },
        compareKeys(from, to){ return Object.keys(from).every(key => from[key] == to[key]); },
        getDescendantVal(desc, obj, ifnull) {
            var objc = obj, arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            if(obj === undefined && ifnull) {
                ifnull.forEach(element => {
                    if(!obj) obj = this.getDescendantVal(objc, element+"."+desc);
                });
            }
            return obj;
        },
        actionClearable(action, payload) {
            clearTimeout(this.awaiting);
            this.awaiting = setTimeout(() => {
                if(payload)
                    this[action](payload);
                else
                    this[action]();
            },
            300);
        },
        calculUnderPosition(target, parent){
            var br = parent.getBoundingClientRect();
            var top = br.top+br.height;
            target.style.transform = "translate("+br.left+"px, "+top+"px)";
            return target;
        },
        searchInListByKey(list, search, key){ return list.filter(obj => search.map(e => e[key]).indexOf(obj[key]) > -1); },
        searchInListObject(list, search, fields, method="startsWith"){
            return list.filter(obj => Object.keys(obj).some(key => {
                var test = obj[key].toLowerCase();
                if(typeof(obj[key]) == "string"){
                    if(fields != undefined){
                        if(fields.includes(key))
                            return method == "exact" ? test == search.toLowerCase() : test[method](search.toLowerCase());
                        return false;
                    }
                    return method == "exact" ? test == search.toLowerCase() : test[method](search.toLowerCase());
                }
                return false;
            }));
        },
        excludeInListByKey(list, exclude, key){ return list.filter(obj => exclude.map(e => e[key]).indexOf(obj[key]) === -1); },
        excludeInListObject(list, exclude, fields){
            return list.filter(obj => Object.keys(obj).some(key => {
                if(typeof(obj[key]) == "string"){
                    if(fields != undefined){
                        if(fields.includes(key))
                            return obj[key].toLowerCase().startsWith(exclude.toLowerCase());
                        return false;
                    }
                    return obj[key].toLowerCase().startsWith(exclude.toLowerCase());
                }
                return false;
            }));
        },
    }
}
